var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { computed, action } from "mobx";
import { RacingStore, RacingEventTypes, RacingEventStatusType } from "../../../data";
import { LeagueEventsCompositeModel, BranchViewEventModel } from "../data";
var RacingCurrentEventsData = /** @class */ (function () {
    function RacingCurrentEventsData(provider, racingGameNavigation) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };
        this.racingGameNavigation = racingGameNavigation;
    }
    // TODO: Remove when new event view is available
    RacingCurrentEventsData.prototype.openRacingGame = function (racecardId, regionId, mode, branchId, trapMarketId, bettingWithoutFavId, bettingWithoutTwoFavId, placeOnlyId, matchBettingId, toteId, totePlaceOnlyId, auPlaceOnlyId, event) {
        this.racingGameNavigation(event, racecardId, regionId, mode, branchId, trapMarketId, bettingWithoutFavId, bettingWithoutTwoFavId, placeOnlyId, matchBettingId, toteId, totePlaceOnlyId, auPlaceOnlyId);
    };
    Object.defineProperty(RacingCurrentEventsData.prototype, "branchViewLeagueEvents", {
        get: function () {
            var e_1, _a, e_2, _b;
            var sortedLeagues = this.racingStore.sortedLeagues;
            var branchViewLeaguesEventsArr = new Array();
            try {
                /* istanbul ignore next */
                for (var sortedLeagues_1 = __values(sortedLeagues), sortedLeagues_1_1 = sortedLeagues_1.next(); !sortedLeagues_1_1.done; sortedLeagues_1_1 = sortedLeagues_1.next()) {
                    var league = sortedLeagues_1_1.value;
                    var hasLiveStream = false;
                    var masterEventsPerLeague = this.racingStore.filteredEventsByLeagueID(this.selectedType, league.masterLeagueId);
                    /* istanbul ignore next */
                    if (masterEventsPerLeague.length === 0) {
                        continue;
                    }
                    var currBranchViewLeagueEvent = new LeagueEventsCompositeModel({ id: league.id, leagueName: league.name, hasLiveStream: false, events: [] });
                    try {
                        /* istanbul ignore next */
                        for (var masterEventsPerLeague_1 = __values(masterEventsPerLeague), masterEventsPerLeague_1_1 = masterEventsPerLeague_1.next(); !masterEventsPerLeague_1_1.done; masterEventsPerLeague_1_1 = masterEventsPerLeague_1.next()) {
                            var masterEvent = masterEventsPerLeague_1_1.value;
                            var currBranchViewEvent = new BranchViewEventModel({
                                id: masterEvent.id,
                                dateTime: masterEvent.date,
                                url: this.getUrl(masterEvent, league),
                                raceProgress: masterEvent.raceProgress,
                                handler: this.openRacingGame.bind(this, this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.RaceCard), this.racingStore.regionId, this.selectedType, Number(this.racingStore.branch.id), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.TrapMarket), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutFav), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutTwoFav), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.PlaceOnly), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.MatchBetting), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTote), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTotePlaceOnly), this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRPlaceOnly))
                            });
                            currBranchViewLeagueEvent.events.push(currBranchViewEvent);
                            hasLiveStream = hasLiveStream || masterEvent.racingEvents.some(this.hasLiveStream);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (masterEventsPerLeague_1_1 && !masterEventsPerLeague_1_1.done && (_b = masterEventsPerLeague_1.return)) _b.call(masterEventsPerLeague_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    currBranchViewLeagueEvent.hasLiveStream = hasLiveStream;
                    branchViewLeaguesEventsArr.push(currBranchViewLeagueEvent);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (sortedLeagues_1_1 && !sortedLeagues_1_1.done && (_a = sortedLeagues_1.return)) _a.call(sortedLeagues_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return branchViewLeaguesEventsArr;
        },
        enumerable: true,
        configurable: true
    });
    RacingCurrentEventsData.prototype.getUrl = function (masterEvent, league) {
        return masterEvent.raceProgress !== RacingEventStatusType.IsResult
            ? this.racingStore.getMasterRacingEventUrl(masterEvent, league)
            : "javascript:void();";
    };
    /* istanbul ignore next */
    RacingCurrentEventsData.prototype.hasLiveStream = function (element) {
        return element && element.hasLiveStream === true;
    };
    /* istanbul ignore next */
    RacingCurrentEventsData.prototype.setParams = function (eventType, regionId, branchId) {
        this.selectedType = eventType;
        /* istanbul ignore next */
        if (regionId && branchId) {
            /* istanbul ignore next */
            this.racingStore.setParams(regionId, branchId);
        }
    };
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], RacingCurrentEventsData.prototype, "branchViewLeagueEvents", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Number, Number]),
        __metadata("design:returntype", void 0)
    ], RacingCurrentEventsData.prototype, "setParams", null);
    return RacingCurrentEventsData;
}());
export { RacingCurrentEventsData };
//# sourceMappingURL=RacingCurrentEventsData.js.map